"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledSpan=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));var _constants=require("../../_constants");var _style=require("../../Icon/_style");var _utils=require("../_utils");function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledSpan=exports.StyledSpan=_styledComponents.default.span`
  font-size: ${_ref=>{let{theme,sSize}=_ref;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.S});}};
  font-weight: ${props=>(0,_utils.getFontWeight)(props.sWeight)};
  font-style: ${props=>(0,_utils.getFontStyle)(props.isAccented)};
  white-space: ${props=>(0,_utils.getWhiteSpace)(props.noWrap)};
  color: ${_ref2=>{let{theme,sColor}=_ref2;return(0,_utils.getColor)({theme,color:sColor});}};
  font-family: ${_ref3=>{let{theme,isDigital}=_ref3;return(0,_utils.getSpanFontFamily)({theme,isDigital});}}; // TODO
  font-variant-numeric: ${props=>props.isDigital?'tabular-nums':'inherit'};
  text-decoration: ${props=>(0,_utils.getTextDecoration)(props.isUnderline)};

  @media (${_constants.MEDIA.TABLET}) {
    font-size: ${_ref4=>{let{theme,sSize}=_ref4;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.M});}};
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    font-size: ${_ref5=>{let{theme,sSize}=_ref5;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.L});}};
  }

  ${_style.StyledIconSvg} {
    ${_ref6=>{let{theme,sColor}=_ref6;return sColor&&`fill: ${(0,_utils.getColor)({theme,color:sColor})}`;}}
  }
`;